import assetPath from '/app/xinglets/profile/main-logged-out/src/xing-id/cover-image/assets/basic_750.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')